import React, { Component } from 'react';
import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import { Provider } from "react-redux";
import store from "./store/store";
import Routes from "./Routes";
import { ToastContainer } from 'react-toastify';

function App() {

  return (
    <Provider store={store}>
      <div>
        <Routes/>
        <ToastContainer/>
      </div>
    </Provider>
  );
  
};

export default App;